import React, { useEffect, useMemo } from "react";

import * as uiHelpers from "./../NoticesUIHelpers";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNoticesUIContext } from "../NoticesUIContext";
import { fetchNotices } from "../../../_redux/notices/NoticesActions";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../../_metronic/_helpers";
import {
  ActionsColumnFormatter,
  DateColumnFormatter,
  NameLinkFormatter,
} from "./column-formatters/index";

export function NoticesTable() {
  const { user } = useSelector((state) => state.auth);

  const noticesUIContext = useNoticesUIContext();

  const noticesUIProps = useMemo(() => {
    return {
      queryParams: noticesUIContext.queryParams,
      setQueryParams: noticesUIContext.setQueryParams,
      viewNoticeButtonClick: noticesUIContext.viewNoticeButtonClick,
      deleteNoticeButtonClick: noticesUIContext.deleteNoticeButtonClick,
    };
  }, [noticesUIContext]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.notices }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchNotices(noticesUIProps.queryParams));
  }, [noticesUIProps.queryParams, dispatch]);

  const columns = [
    {
      dataField: "name",
      text: "نام",
      formatter: NameLinkFormatter,
    },
    {
      dataField: "createDate",
      text: "تاریخ ایجاد",
      formatter: DateColumnFormatter,
    },
    {
      dataField: "branchName",
      text: "نام شعبه",
    },
    {
      dataField: "action",
      text: "عملیات",
      formatter: ActionsColumnFormatter,
      formatExtraData: {
        user,
        deleteNoticeButtonClick: noticesUIProps.deleteNoticeButtonClick,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: noticesUIProps.queryParams.pageSize,
    page: noticesUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => (
          <Pagination isLoading={listLoading} paginationProps={paginationProps}>
            <BootstrapTable
              wrapperClasses={"table-responsive"}
              bordered={false}
              classes={
                "table table-head-custom table-vertical-header overflow-hidden"
              }
              bootstrap4
              remote
              keyField={"id"}
              data={entities === null ? [] : entities}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                noticesUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        )}
      </PaginationProvider>
    </>
  );
}
